export default () => ({
  root: {
    display: 'flex',
  },
});



// WEBPACK FOOTER //
// ./src/form-field-styles.js